import { createContext } from 'react'
import { UseIntervals } from './types'

export const IntervalsContext = createContext<UseIntervals>(null)
